import { render, staticRenderFns } from "./repeat_compact.vue?vue&type=template&id=3ab6b0cc&scoped=true"
import script from "./repeat_compact.vue?vue&type=script&lang=js"
export * from "./repeat_compact.vue?vue&type=script&lang=js"
import style0 from "./repeat_compact.vue?vue&type=style&index=0&id=3ab6b0cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab6b0cc",
  null
  
)

export default component.exports